export enum RegistrationPage {
  FeatureAdvisory = "feature_advisory",
  PersonalInformation = "personal_information",
  RequiredConsentNotices = "required_consent_notices",
  OptionalConsentNotices = "optional_consent_notices",
  AccountInformation = "account_information",
  EmailVerification = "email_verification",
  Password = "password",
}
